import _ from 'lodash';
import { AllIWantData } from '../AllIWant';
import CustomField from '../Model/CustomField';
import AppService from 'App/legacy/AppService';

type RawCustomField = Optional<CustomField, '$hasAccess'>;

const hasRoleAccess = function (
	field: RawCustomField,
	roleId: number | null,
	admin: boolean,
	self: AllIWantData['self']
) {
	if (!self.features.userPermissionsAdvanced) {
		return true;
	}

	if (admin || !field.roles?.length || _.find(field.roles, { id: roleId })) {
		return true;
	}

	return false;
};

export default function parseCustom(field: RawCustomField) {
	const customerSelf = AppService.getSelf();
	const self = AppService.getAccountSelf();

	// if customerSelf is still missing and DEV
	if (!customerSelf && Tools.ENV === 'DEV') {
		console.warn('Customfields got parsed before app was initialized! use AppService.getCustomFields.');
		console.trace();
	}
	field.$hasAccess = hasRoleAccess(field, customerSelf.role?.id || null, customerSelf.administrator, self);

	if (AppService.getMetadata()?.params?.AdminSkipRequiredFields) {
		const isAdmin = customerSelf.administrator;
		const hasRoleRestrictions = field.roles?.length > 0;
		const userRoleNotInAllowedRoles = !_.find(field.roles, { id: customerSelf.role?.id });
		if (isAdmin && hasRoleRestrictions && userRoleNotInAllowedRoles) {
			field.obligatoryField = 0;
		}
	}

	// Fix select default
	if (['Select', 'MultiSelect'].indexOf(field.datatype) >= 0 && field.default) {
		try {
			const options: string[] = [];
			_.each(field.default, function (opt) {
				const trm = _.trim(opt);
				if (trm.length) {
					options.push(trm);
				}
			});
			field.default = options;
		} catch {
			console.warn('Failed to parse options for customfield: ' + field.id);
			console.trace();
		}
	}

	return field as CustomField;
}
